module.exports = __webpack_public_path__ + "img/wait.fbcf9bd7.svg";